import React,{createRef, forwardRef,useImperativeHandle,useEffect, useState,useRef } from 'react';
import { Form,Modal} from "reactstrap";
import Swal from 'sweetalert2';
import { Controller, useForm } from "react-hook-form";

import API from '../../API';
import { DateFormat,DateFormatJSON, DateThai,MobileFormat, NumberFormat,CleanMobile, TimeFormat,APIURL,GetAuthorization } from '../../Utils/Function';
import {SearchSubDistrict,SearchCustomer} from '../../Utils/Search';
import { UploadCard,DeleteFile,FilePreviewCard } from '../../Components';

import parse from 'html-react-parser'
import moment from 'moment';
import AsyncSelect from 'react-select/async';

const PackageGroupCreate = forwardRef((props,ref) =>{
    const { register, handleSubmit, watch, reset, getValues,setValue, control, formState: { errors } } = useForm();

    const [ModalState,setModalState] = useState(false);
    const [_PackageGroupList,setPackageGroupList] = useState([]);
    const [_PriceList,setPriceList]=  useState([]);
    const [_FoodMenuList,setFoodMenuList] = useState([]);
    const [_FoodGroupList,setFoodGroupList] = useState([]);
    const [_Detail,setDetail] = useState(null);

    const _UploadRef = useRef();
    const _FilePreviewRef = useRef();
    const [_FileList,setFileList] = useState([]);

    useEffect(() => {
        (async () => {

        })();

        return ()=>{ }
    }, []);
    
    useImperativeHandle(ref, () => ({
        Show(PackageGroupID){            
            _ClearValuAction();
            setDetail(null);
            if(PackageGroupID === undefined){
                setModalState(true);
            }else{
                _LoadDetail(PackageGroupID);
            }
        }

      }));
   
    const _LoadDetail = async (PackageGroupID)=>{
        API({method : "get",url:"/Package/Group/"+PackageGroupID}).then(res=>{
            if (res.status !== 200) {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message,
                });
                return;
            }

            if (!res.data.Status) {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message,
                });
                return;
            }
            setDetail(res.data.Data);
            setFoodMenuList(res.data.Data.Menu);
            setPriceList(res.data.Data.Prices);
            setValue('PackageGroupName',res.data.Data.PackageGroupName);
            setValue('QuantityLimit',res.data.Data.QuantityLimit);
            setValue('Description',res.data.Data.Description);
            setValue('Remark',res.data.Data.Remark);
            _UploadGetFileLsit(res.data.Data.PackageGroupId);
            setModalState(true);
        }).catch(res => {
            Swal.fire({
                icon: 'error',
                title: res.data.Message,
            });
            return;
        });
    }

    const _Save = async()=>{
        if(getValues('PackageGroupName') == undefined || getValues('PackageGroupName') === ""){
            Swal.fire({
                icon: 'error',
                title: 'ชื่อกลุ่มแพ็คเก็จ'
            });
            return;
        }

        if(getValues('QuantityLimit') == undefined || isNaN(getValues('QuantityLimit'))){
            Swal.fire({
                icon: 'error',
                title: 'โปรดตรวจสอบ ราคา'
            });
            return;
        }

        let _reqObj = {
            PackageGroupId   : (_Detail != null ? _Detail.PackageGroupId : null),
            PackageGroupName : getValues('PackageGroupName'),
            QuantityLimit    : Number(getValues('QuantityLimit')),
            Description      : getValues('Description'),
            Remark           : getValues('Remark'),
        }

        Swal.fire({
            icon: 'warning',
            title: 'ต้องการบันทึก หรือไม่ ?',
            text : '',
            showCancelButton : true,
            confirmButtonText: 'บันทึก',
            confirmButtonColor:'#d33',
            cancelButtonText:'ยกเลิก'
        }).then((r)=>{
            if(!r.isConfirmed){
                return;
            }

            API({method : 'post',url:'/Package/Group/Save',data:_reqObj}).then(res=>{
                if(!res.data.Status){
                    Swal.fire({
                        icon: 'error',
                        title: res.data.Message
                    });
                    return;
                }
                setModalState(false);
                _ClearValuAction();
                if(props.update != undefined){
                    try{
                        props.update(res.data.Data);
                    }catch(e){
                        console.log(e);
                    }
                }
            }).catch(res => {
                if(res.response.data != undefined){
                    Swal.fire({
                        icon: 'error',
                        title: res.code,
                        text: res.response.data.Message
                    });
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'การเชื่อมต่อผิดพลาด',
                        text: res.message+' ['+res.code+']',
                    });
                }
                

            });
        });
    }

    const _ClearValuAction = ()=>{
        reset();
    }
    const _ClearValue = ()=>{
        Swal.fire({
            icon: 'warning',
            title: 'ต้องการล้างข้อมูล หรือไม่ ?',
            text : '',
            showCancelButton : true,
            confirmButtonText: 'ตกลง',
            confirmButtonColor:'#d33',
            cancelButtonText:'ยกเลิก'
        }).then((r)=>{
            if(!r.isConfirmed){
                return;
            }
            _ClearValuAction();
        });
    }
    const _UploadAddItem = (RefID)=>{
        _UploadGetFileLsit(RefID)
    }
    const _UploadGetFileLsit = async(RefID)=>{
            setFileList([]);
            API({method : "get",url:"/File/PACKAGEGROUP/"+RefID}).then(res=>{
                if (res.status !== 200) {
                    return;
                }
    
                if (!res.data.Status) {
                    return;
                }
                setFileList(res.data.Data);
            }).catch(res => {
                return;
            });
    }
      return (
        <>
        <Modal isOpen={ModalState} className={'modal-xl'} centered={true} unmountOnClose={true}>
            <div className="modal-header">
                <h5 className="modal-title">{(_Detail != null ? "แก้ไขข้อมูลกลุ่มแพ็คเก็จ":"สร้างกลุ่มแพ็คเก็จ")}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"  onClick={()=>{setModalState(false)}}></button>
            </div>
            <div className='modal-body' style={{'minHeight':'300px'}}>
                <Form onSubmit={handleSubmit(_Save)} className='row g-3'>
                    <div className='row mt-4'>
                        <div className="col-md-5">
                            <label className="form-label">ชื่อกลุ่มแพ็คเก็จ</label>
                                <input type='text' className="form-control" placeholder="ชื่อกลุ่มแพ็คเก็จ" autoComplete="off"   {...register("PackageGroupName", { required: false })}/>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label">จำนวนจำกัด</label>
                            <input type='number' maxLength={5} min={0} className="form-control text-end" placeholder="จำนวนจำกัด" autoComplete="off"   {...register("QuantityLimit", { required: false })}/>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className="col-md-12">
                            <label className="form-label">รายละเอียด</label>
                            <Controller name="Description" control={control} rules={{required:false}} render={({field})=>(
                                <textarea className="form-control" autoComplete="off"  onChange={(e)=>field.onChange(e)} defaultValue={field.value}/>
                            )} />
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className="col-md-12">
                            <label className="form-label">หมายเหตุ</label>
                            <Controller name="Remark" control={control} rules={{required:false}} render={({field})=>(
                                <textarea className="form-control" autoComplete="off"  onChange={(e)=>field.onChange(e)} defaultValue={field.value}/>
                            )} />
                        </div>
                    </div>
                    {(_Detail != null?<>
                    <div className='row mt-4 mb-2'>
                        <div className='col-lg-12'>
                            <div className='card'>
                                <div className='card-header text-end'>
                                    <div className='btn-group btn-group-sm'>
                                        <button className='btn btn-success' type="button" onClick={()=>{_UploadRef.current.Open('PACKAGEGROUP',_Detail.PackageGroupId,undefined,(e)=>{_UploadAddItem(_Detail.PackageGroupId);})}}>Upload</button>
                                    </div>
                                </div>
                                <div className='card-body'>
                                    {_FileList.map((v,i)=>(
                                        <div className='row mt-2 mb-2' key={i}>
                                            <div className='col-lg-3'>
                                                <a href='#' onClick={(e)=>{_FilePreviewRef.current.Open(v);}}>
                                                    <img className='form-control' src={APIURL()+'/File/'+GetAuthorization()+'/'+v.FileID+'/Preview'}/>
                                                </a>
                                            </div>
                                            <div className='col-lg-6 fs-6'>{v.FileName}</div>
                                            <div className='col-lg-3 text-center'>
                                                <button className='btn btn-danger' type='button' onClick={()=>{DeleteFile(v.FileID,()=>{_UploadGetFileLsit(_Detail.PackageId);});}}>ลบ</button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    </>:'')}        
                    <div className='row mt-3'>
                        <div className='col-md-12 mt-4 text-end'>
                            <div className='btn-group btn-group-lg'>
                                <button type="button" className='btn btn-danger' disabled={(_Detail != null ? true:false)} onClick={()=>{_ClearValue();}}>ล้างข้อมูล</button>
                                <button type="submit" className='btn btn-success'>บันทึก</button>
                            </div>
                        </div>
                    </div>
                    </Form>
            </div>
        </Modal>
        <UploadCard ref={_UploadRef} />
        <FilePreviewCard ref={_FilePreviewRef} />
        </>
      )
});
export default React.memo(PackageGroupCreate);